import { Controller } from "@hotwired/stimulus";

// Shows the scroll-to-top button once this scroll box has scrolled past `offset`.
// Watches a zero-height sentinel at the top of the box instead of listening for
// scroll: the callback runs only when the threshold is crossed, so scrolling does
// no per-frame work and forces no style recalc.
export default class extends Controller {
  static targets = ["sentinel", "button"];
  static values = { offset: { type: Number, default: 50 } };

  connect() {
    this.scrolled = false;
    // Growing the root's top edge by `offset` keeps the sentinel intersecting until
    // it is more than `offset` above the visible top — i.e. scrollTop > offset.
    this.observer = new IntersectionObserver(
      ([entry]) => this.toggle(!entry.isIntersecting),
      { root: this.element, rootMargin: `${this.offsetValue}px 0px 0px 0px` }
    );
    this.observer.observe(this.sentinelTarget);
  }

  disconnect() {
    this.observer?.disconnect();
  }

  // A swap can replace the button while scrolled; render it in the current state.
  buttonTargetConnected(button) {
    button.classList.toggle("d-none", this.scrolled !== true);
  }

  toggle(scrolled) {
    if (scrolled === this.scrolled) return;
    this.scrolled = scrolled;
    this.buttonTargets.forEach((button) => button.classList.toggle("d-none", !scrolled));
  }
}
